import { env } from 'next-runtime-env';

import { isHostLocal } from '~utils/host';

export enum EnvType {
	Dev = 'development',
	Stage = 'stage',
	Production = 'production',
}

export const getEnv = (): EnvType => {
	const host = window.location.hostname;
	const isLocal = isHostLocal(host);
	const isStage =
		(host.includes('npstage') || host.includes('nptest')) &&
		env('NEXT_PUBLIC_PUBLIC_API') !== 'https://api.ifriend.ai';

	let val;
	if (isLocal || process.env.NODE_ENV === 'development') {
		val = EnvType.Dev;
	} else if (isStage) {
		val = EnvType.Stage;
	} else {
		val = EnvType.Production;
	}
	return val;
};
